import React from 'react';
import { Calendar, X } from 'lucide-react';

interface DateInputProps {
  dates: Date[];
  onChange: (dates: Date[]) => void;
  error?: string;
}

export function DateInput({ dates, onChange, error }: DateInputProps) {
  const [newDate, setNewDate] = React.useState('');

  const handleAddDate = (e: React.FormEvent) => {
    e.preventDefault();
    if (newDate) {
      onChange([...dates, new Date(newDate)]);
      setNewDate('');
    }
  };

  const handleRemoveDate = (index: number) => {
    onChange(dates.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="date"
            value={newDate}
            onChange={(e) => setNewDate(e.target.value)}
            className={`w-full pl-10 pr-4 py-2 rounded-lg border ${
              error 
                ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
            } focus:ring-1`}
          />
        </div>
        <button
          type="button"
          onClick={handleAddDate}
          disabled={!newDate}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-50"
        >
          Adicionar
        </button>
      </div>

      <div className="flex flex-wrap gap-2">
        {dates.map((date, index) => (
          <span
            key={index}
            className="inline-flex items-center gap-1 px-3 py-1 bg-blue-50 text-blue-800 rounded-full text-sm"
          >
            {date.toLocaleDateString()}
            <button
              type="button"
              onClick={() => handleRemoveDate(index)}
              className="p-0.5 hover:bg-blue-100 rounded-full"
            >
              <X size={14} />
            </button>
          </span>
        ))}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}